import axiosInstance from "../interceptor/instance";
import { formatRolesFrontEndToBAckEnd } from "../../utils/filterRoles";

const baseUrl = `${process.env.REACT_APP_BASE_URL_USER}/user`;
const tempBaseUrl = `${process.env.REACT_APP_BASE_URL_USER}/template`;
const groupBaseUrl = `${process.env.REACT_APP_BASE_URL_USER}/user-group`

export const getAllModelNames = async () => {
  const response = await axiosInstance.get(
    `${tempBaseUrl}/name`
  );
  return response.data;
};

export const getAllUsers = async (page, key, order, role, limit, name) => {
  const filteredRole = formatRolesFrontEndToBAckEnd(role);
  const responseRole = await axiosInstance.get(
    baseUrl,
    {
      params: {
        limit: limit,
        offset: page,
        key: key,
        order: order,
        role: filteredRole === "init" || filteredRole === null ? undefined : filteredRole,
        name: name
      },
    }
  );
  return responseRole.data;
};

export const editUser = async (user) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/${user.id}`,
    {
      user_role: user.user_role,
      templates: user.templates,
      group: user.user_group
    }
  );
  if (response.status !== 200) return "Unauthorized";
  return response.data;
};

export const setActiveInactive = async (user) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/status/${user}`,
    {}
  );
  if (response.status !== 200) return "Unauthorized";
  return response.data;
};

export const createUser = async (user) => {
  const response = await axiosInstance.post(
    baseUrl,
    user
  );
  return response.data;
};

export const getCurrentUserDetails = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/auth`
  );
  return response.data;
};

export const updateUserPreferedZoom = async (userId, preferedZoomLevels) => {
  const response = await axiosInstance.patch(
    `${baseUrl}/zoomLevels/${userId}`,
    {preferedZoomLevels}
  );
  if (response.status !== 200) return "Unauthorized";
  return response.data;
};

//get all user groups
export const getAllUserGroups = async (page, limit, name) => {
  const responseRole = await axiosInstance.get(
    groupBaseUrl,
    {
      params: {
        limit: limit,
        offset: page,
        name: name === "init" || name === null ? undefined : name,
      },
    }
  );
  return responseRole.data;
};

// change active status of group
export const setActiveInactiveGroup = async (user) => {
  const response = await axiosInstance.patch(
    `${groupBaseUrl}/status/${user}`,
    {}
  );
  if (response.status !== 200) return "Unauthorized";
  return response.data;
};

// get group permissions
export const getAllUserGroupPermissions = async () => {
  const response = await axiosInstance.get(
    `${groupBaseUrl}/permissions`,
  );
  return response.data;
};

// get countries
export const getCountries = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/country`,
  );
  return response.data;
};

// get all operators
export const getAllOperators = async () => {
  const response = await axiosInstance.get(
    `${groupBaseUrl}/all-operators`,
  );
  return response.data;
};

//create group
export const createGroup = async (group) => {
  const response = await axiosInstance.post(
    groupBaseUrl,
    group
  );
  return response.data;
};

//update user group
export const updateUserGroup = async (groupId, group) => {
  const response = await axiosInstance.put(
    `${groupBaseUrl}/${groupId}`,
    group
  );
  return response.data;
};

export const getUserUploadedFiles = async () => {
  const response = await axiosInstance.get(
    `${baseUrl}/uploaded-files`,
  );
  return response.data;
};